module.exports = __webpack_public_path__ + "img/685-b5e57c.png";